// database/repositories/exampleRepository.ts
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../client';
import { seedDatabaseIfEmpty, type SeedOptions } from '../seed';

export const exampleRepository = {
  async getSeedIds(): Promise<Array<string>> {
    const metricIds = await db.metrics.toCollection().limit(50).primaryKeys();
    return metricIds ?? [];
  },

  async seedDatabaseIfEmpty(opts?: SeedOptions) {
    await seedDatabaseIfEmpty(opts);
  },
};

export function useSeedIds() {
  return useLiveQuery(() => exampleRepository.getSeedIds(), []);
}
